<ch-header #header>
  <header class="navbar w-100 shadow-sm fixed-top p-2" [ngClass]="{'dark-skin': darkModeService.isDarkModeOn()}">
    <div class="row w-100">

      <div class="col-4 ps-3">
        <a [routerLink]="'/'">
          <div class="logo-container">
            <img src="assets/FXCH.v2.1.png" alt="fxch-logo" height="100%"/>
          </div>
        </a>
        <div class="logo-txt" [ngClass]="{'dark-skin': darkModeService.isDarkModeOn()}">Accounts</div>
      </div>

      <div class="col-16 text-center">
        <h4 class="text-uppercase text-primary mb-0">{{ title }}</h4>
        <p class="mb-0 btn-group">
          <button type="button" class="btn" [ngClass]="statusAccount ? 'btn-primary' : 'btn-outline-primary'" (click)="tabClickAccount();selectTab(0)">Accounts</button>
          <button type="button" class="btn" [ngClass]="statusGroup ? 'btn-primary' : 'btn-outline-primary'" (click)="tabClickGroups();selectTab(1)">Groups</button>
        </p>
      </div>

      <ch-logout class="col-4 text-end pe-0" (logoutEvent)="header.logout()">
      </ch-logout>



    </div>
  </header>
</ch-header>


<div class="first-block tabs accountsTabset">
  <tabset #staticTabs>
    <tab>
      <div class="table-container">

<!--        <span [ngClass]="darkModeService.isDarkModeOn() ? 'text-secondary' : 'text-black'">CRM ID: <b>8161d41c-617b-4e00-d88f-49ede95f8938</b></span>-->
        <span class="text-primary">CRM ID: <b>8161d41c-617b-4e00-d88f-49ede95f8938</b></span>

        <table class="table table-bordered table-hover" [ngClass]="{'dark-skin': darkModeService.isDarkModeOn()}">
          <thead>
          <tr>
            <th scope="col" class="col-id">

              <div class="d-flex justify-content-center align-items-center">
                <span>Account ID</span>
                <div class="order-container" (click)="setAccountOrder('id')">
                  <i class="fa" [ngClass]="getAccountClass('id')"></i>
                  <i *ngIf="!accountOrder['id']" class="fa fa-angle-up disabled"></i>
                  <span class="badge rounded-pill" *ngIf="accountOrder['id']">{{accountOrder['id'].order}}</span>
                </div>
              </div>


            </th>
            <th scope="col">
              <div class="d-flex justify-content-center align-items-center">
                <span>Account name</span>
                <div class="order-container" (click)="setAccountOrder('name')">
                  <i class="fa" [ngClass]="getAccountClass('name')"></i>
                  <i *ngIf="!accountOrder['name']" class="fa fa-angle-up disabled"></i>
                  <span class="badge rounded-pill" *ngIf="accountOrder['name']">{{accountOrder['name'].order}}</span>
                </div>
              </div>

            </th>
            <th scope="col">
              <div class="d-flex justify-content-center align-items-center">
                <span>Email addresses</span>
                <div class="order-container" (click)="setAccountOrder('emailAddresses')">
                  <i class="fa" [ngClass]="getAccountClass('emailAddresses')"></i>
                  <i *ngIf="!accountOrder['emailAddresses']" class="fa fa-angle-up disabled"></i>
                  <span class="badge rounded-pill" *ngIf="accountOrder['emailAddresses']">{{accountOrder['emailAddresses'].order}}</span>
                </div>
              </div>

            </th>
            <th scope="col">
              <div class="d-flex justify-content-center align-items-center">
                <span>Report email addresses</span>
                <div class="order-container" (click)="setAccountOrder('reportEmailAddresses')">
                  <i class="fa" [ngClass]="getAccountClass('reportEmailAddresses')"></i>
                  <i *ngIf="!accountOrder['reportEmailAddresses']" class="fa fa-angle-up disabled"></i>
                  <span class="badge rounded-pill" *ngIf="accountOrder['reportEmailAddresses']">{{accountOrder['reportEmailAddresses'].order}}</span>
                </div>
              </div>

            </th>
            <th scope="col" class="col-edit"></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let item of preload.accounts | multiOrder:accountOrder">
            <td>{{item.id}}</td>
            <td>{{item.name}}</td>
            <td>{{item.emailAddresses}}</td>
            <td>{{item.reportEmailAddresses}}</td>
            <td class="text-center">
              <i class="fa fa-lg fa-user-edit" (click)="updateAccount(item)"></i>
            </td>
          </tr>
        </table>

      </div>
    </tab>
    <tab>
      <div class="table-container">

        <table class="table table-bordered table-hover bg-white" [ngClass]="{'dark-skin': darkModeService.isDarkModeOn()}">
          <thead>
          <tr>
            <th scope="col" class="col-id">
              <div class="d-flex justify-content-center align-items-center">
                <span>Group ID</span>
                <div class="order-container" (click)="setGroupOrder('id')">
                  <i class="fa" [ngClass]="getGroupClass('id')"></i>
                  <i *ngIf="!groupOrder['id']" class="fa fa-angle-up disabled"></i>
                  <span class="badge rounded-pill" *ngIf="groupOrder['id']">{{groupOrder['id'].order}}</span>
                </div>
              </div>
            </th>
            <th scope="col">
              <div class="d-flex justify-content-center align-items-center">
                <span>Group name</span>
                <div class="order-container" (click)="setGroupOrder('name')">
                  <i class="fa" [ngClass]="getGroupClass('name')"></i>
                  <i *ngIf="!groupOrder['name']" class="fa fa-angle-up disabled"></i>
                  <span class="badge rounded-pill" *ngIf="groupOrder['name']">{{groupOrder['name'].order}}</span>
                </div>
              </div>
            </th>
            <th scope="col" class="col-edit"></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let item of preload.groups | multiOrder:groupOrder">
            <td>{{item.id}}</td>
            <td>{{item.name}}</td>
            <td class="text-center">
              <i class="fa fa-lg fa-user-edit" (click)="updateGroup(item)"></i>

              <!--<span class="fa-stack fa-lg">-->
              <!--  <i class="fa fa-circle fa-stack-2x"></i>-->
              <!--  <i class="fa fa-user-edit fa-stack-1x"></i>-->
              <!--</span>-->
            </td>
          </tr>
        </table>

      </div>
    </tab>
  </tabset>
</div>






